import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';
import { completeProfile } from '../../services/patientService';

export default function ProfileSetupPage() {
  const navigate            = useNavigate();
  const { profileComplete } = useAuth();
  const [form, setForm]     = useState({ name: '', gender: '', age: '' });
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const handleSubmit = async () => {
    if (!form.name.trim()) { toast.error('Name is required'); return; }
    if (!form.gender)      { toast.error('Select your gender'); return; }
    if (!form.age || form.age < 1 || form.age > 120) { toast.error('Enter valid age'); return; }

    setLoading(true);
    try {
      const res = await completeProfile({ name: form.name, gender: form.gender, age: Number(form.age) });
      profileComplete(res.user);
      toast.success('Profile saved!');
      navigate('/', { replace: true });
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface flex flex-col">
      <div className="flex items-center px-4 py-4 border-b border-border bg-white">
        <span className="text-xl font-bold text-primary font-heading">FARISTAA</span>
      </div>

      <div className="flex-1 flex flex-col justify-center px-6 py-8 max-w-md mx-auto w-full">
        <div className="w-16 h-16 bg-primary-light rounded-2xl flex items-center justify-center mb-6 mx-auto">
          <i className="fa-solid fa-user text-primary text-2xl" />
        </div>
        <h1 className="text-2xl font-bold text-text-primary font-heading mb-1 text-center">
          Complete Your Profile
        </h1>
        <p className="text-sm text-text-secondary text-center mb-8">
          Just a few details to get started
        </p>

        <div className="space-y-4">
          <div>
            <label className="input-label">Full Name</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => set('name', e.target.value)}
              placeholder="Your full name"
              className="input"
              autoFocus
            />
          </div>

          <div>
            <label className="input-label">Gender</label>
            <div className="flex gap-3">
              {['Male', 'Female', 'Other'].map((g) => (
                <button
                  key={g}
                  onClick={() => set('gender', g)}
                  className={`flex-1 py-3 rounded-btn border font-medium text-sm transition-all ${
                    form.gender === g
                      ? 'border-primary bg-primary-light text-primary'
                      : 'border-border text-text-secondary'
                  }`}
                >
                  {g === 'Male' && <i className="fa-solid fa-mars mr-1.5" />}
                  {g === 'Female' && <i className="fa-solid fa-venus mr-1.5" />}
                  {g === 'Other' && <i className="fa-solid fa-genderless mr-1.5" />}
                  {g}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="input-label">Age</label>
            <input
              type="number"
              value={form.age}
              onChange={(e) => set('age', e.target.value)}
              placeholder="Your age"
              min={1}
              max={120}
              className="input"
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="btn-primary mt-2"
          >
            {loading
              ? <span className="flex items-center justify-center gap-2"><i className="fa-solid fa-spinner animate-spin" />Saving...</span>
              : 'Continue →'}
          </button>
        </div>
      </div>
    </div>
  );
}
